import React from 'react';
import { Icon } from '@iconify/react';
import { Smile } from 'lucide-react';

export default function PhotoMemeSection({ memeCaseLabels, selectedMeme, onSelectMeme, onOpenSamplePopup }) {
  return (
    <div className="photo-section-card">
      <div className="photo-section-header">
        <div className="photo-section-title-wrapper">
          <h3 className="photo-section-title">최신 유행 스타일 선택</h3>
          <button className="photo-sample-btn" onClick={onOpenSamplePopup}>
            샘플 사진 보기
          </button>
        </div>
        <div className="photo-section-icon photo-icon-orange">
          <Smile size={20} />
        </div>
      </div>

      <div className="photo-option-grid">
        {[...memeCaseLabels, { title: '사진 그대로', field: null }].map((meme, index) => {
          const memeTitle = typeof meme === 'string' ? meme : meme.title;
          const memeField = typeof meme === 'string' ? null : meme.field;
          const uniqueKey = `meme-${index}-${memeTitle}-${memeCaseLabels
            .map((m) => (typeof m === 'string' ? m : m.title))
            .join('-')}`;

          const isSelected =
            typeof meme === 'string'
              ? selectedMeme === meme
              : typeof selectedMeme === 'string'
                ? selectedMeme === memeTitle
                : selectedMeme?.title === memeTitle;

          let imagePath = null;
          if (memeField === 'title1') imagePath = '/case1.png';
          else if (memeField === 'title2') imagePath = '/case2.png';
          else if (memeField === 'title3') imagePath = '/case3.png';
          else if (memeTitle === '사진 그대로') imagePath = '/real.png';

          return (
            <button
              key={uniqueKey}
              className={`photo-option-btn ${isSelected ? 'active' : ''}`}
              onClick={() => onSelectMeme(memeTitle)}
            >
              {imagePath ? (
                <img
                  src={imagePath}
                  alt={memeTitle}
                  className="meme-icon-image"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const fallback = document.createElement('span');
                    fallback.className = 'meme-emoji';
                    fallback.textContent = index === 0 ? '😎' : index === 1 ? '🔥' : '✨';
                    e.target.parentNode.insertBefore(fallback, e.target);
                  }}
                />
              ) : (
                <span className="meme-emoji">{index === 0 ? '😎' : index === 1 ? '🔥' : '✨'}</span>
              )}
              <span>{memeTitle}</span>
              {isSelected && (
                <div className="checkmark">
                  <Icon icon="solar:check-circle-bold" width={16} height={16} />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}


